import {
  Autocomplete,
  Box,
  Button,
  Chip,
  Container,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  Radio,
  RadioGroup,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import Header from "../components/Admin/header/Header";
import Sidebar from "../components/Admin/Sidebar/Sidebar";
import { Close, SearchRounded } from "@mui/icons-material";
import { DatePicker } from "@mui/x-date-pickers";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const MasterSharingHospitalReport = () => {
  const navigate = useNavigate();
  return (
    <Container maxWidth={false} disableGutters>
      <Header />
      <Box sx={{ display: "flex" }}>
        <Sidebar />
        <Box sx={{ width: "100%", pr: "90px", py: "20px" }}>
          <Button
            startIcon={<ArrowBackIcon />}
            onClick={() => navigate(-1)}
            sx={{
              color: '#5D6A82', 
              textTransform: 'none', 
              fontSize: '16px',
              fontWeight: 'bold',
              padding: 0,
              transition: 'none !important',
            }}
            >
              Back
          </Button>
          {/* heading  */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: "20px",
            }}
          >
            <Typography sx={{ color: "rgba(93, 106, 130, 1)", fontSize: 20 }}>
              Hospital Sharing Report
            </Typography>
            {/* <IconButton>
              <Close />
            </IconButton> */}
          </Box>

          <Grid container spacing={2} sx={{ mb: "20px" }}>
            <Grid item xs={12} sm={6} md={4}>
              <Autocomplete
                options={[]}
                renderInput={(params) => (
                  <TextField {...params} label="Search Template" />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Autocomplete
                options={[]}
                renderInput={(params) => (
                  <TextField {...params} label="User Type" />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Autocomplete
                options={[]}
                renderInput={(params) => (
                  <TextField {...params} label="Visit Type" />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6} xl={5}>
              <FormControl component="fieldset">
                <RadioGroup name="date" row defaultValue="openBill">
                  <FormControlLabel
                    value="openBill"
                    control={<Radio />}
                    label="Open Bill"
                  />
                  <FormControlLabel
                    value="generatedDate"
                    control={<Radio />}
                    label="Generated Date"
                  />
                  <FormControlLabel
                    value="approveDate"
                    control={<Radio />}
                    label="Approve Date"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} xl={7}>
              <Autocomplete
                limitTags={3}
                multiple
                options={[
                  "Dr. Anima Patel",
                  "Dr. Alok Sen",
                  "Dr. Rituraj Singh",
                ]}
                renderInput={(params) => (
                  <TextField {...params} label="User Name" fullWidth required />
                )}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Chip
                      key={option}
                      label={option}
                      {...getTagProps({ index })}
                      sx={{
                        bgcolor: "transparent",
                        borderRadius: "5px",
                        border: "1px solid #ccc",
                        "& .MuiChip-deleteIcon": {
                          "&:hover": { color: "grey" },
                        },
                      }}
                    />
                  ))
                }
              />
            </Grid>

            {/* start and end date */}
            <Grid item xs={12} sm={6} md={4}>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={6}>
                  <DatePicker
                    name="startDate"
                    label="Start Date"
                    slotProps={{
                      textField: { required: true, fullWidth: true },
                    }}
                    sx={{ bgcolor: "white" }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <DatePicker
                    name="endDate"
                    label="End Date"
                    slotProps={{
                      textField: { required: true, fullWidth: true },
                    }}
                    sx={{ bgcolor: "white" }}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <TextField label="Bill No" fullWidth />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <TextField label="Patient ID" fullWidth />
            </Grid>
          </Grid>

          <Box
            sx={{
              border: `1px solid #CCD4DA`,
              borderRadius: "12px",
              mb: "20px",
              p: "20px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: "20px",
              }}
            >
              <Typography>Display Print Group Wise</Typography>
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <Button variant="outlined" sx={{ textTransform: "none" }}>
                  Category
                </Button>
                <Button variant="outlined" sx={{ textTransform: "none" }}>
                  Sub Category
                </Button>
                <Button variant="outlined" sx={{ textTransform: "none" }}>
                  Add Group
                </Button>
              </Box>
            </Box>

            <TableContainer component={Paper}>
              <Table>
                <TableHead
                  sx={{
                    bgcolor: "#EAEAEA",
                  }}
                >
                  <TableRow>
                    <TableCell>Name</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell></TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>

          <Typography sx={{ my: "20px", color: "#5D6A82" }}>
            <Box component="span" sx={{ fontWeight: 600, color: "black" }}>
              Note:{" "}
            </Box>
            Provide either the Bill Date Range, Patient ID, Or Bill Number.
          </Typography>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              gap: 1,
              mb: "20px",
            }}
          >
            <Button
              variant="outlined"
              sx={{ textTransform: "none", width: "150px" }}
            >
              Print Report
            </Button>
            <Button
              variant="contained"
              sx={{ textTransform: "none", width: "150px" }}
            >
              Search
            </Button>
            <Button
              variant="contained"
              sx={{ textTransform: "none", width: "150px" }}
            >
              Create Dr Bill
            </Button>
          </Box>

          <Grid container spacing={2}>
            <Grid item xs={12} sm={5} md={4} xl={3}>
              <Box
                sx={{
                  border: `1px solid #CCD4DA`,
                  borderRadius: "12px",
                  p: "20px",
                  height: "200px",
                  display: "flex",
                  flexDirection: "column",
                  gap: 1,
                }}
              >
                <TextField
                  placeholder="Search"
                  fullWidth
                  size="small"
                  slotProps={{
                    input: {
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchRounded />
                        </InputAdornment>
                      ),
                      sx: {
                        borderRadius: "10px",
                      },
                    },
                  }}
                  sx={{ mb: "12px" }}
                />
                <Typography>Dr. Anima Patel</Typography>
                <Typography>Dr. Alok Sen</Typography>
                <Typography>Dr. Rituraj Singh</Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={7} md={8} xl={9}>
              <Box
                sx={{
                  border: `1px solid #CCD4DA`,
                  borderRadius: "12px",
                  p: "20px",
                  display: "flex",
                  flexDirection: "column",
                  gap: 1,
                }}
              >
                <Typography sx={{ mb: "12px" }}>
                  Sharing Amount Summary
                </Typography>
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead
                      sx={{
                        bgcolor: "#EAEAEA",
                      }}
                    >
                      <TableRow>
                        <TableCell>User</TableCell>
                        <TableCell>Cost</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell>Dr. Anima Patel</TableCell>
                        <TableCell>₹16,000</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>Dr. Alok Sen</TableCell>
                        <TableCell>₹8,000</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>Dr. Rituraj Singh</TableCell>
                        <TableCell>₹7,400</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Container>
  );
};

export default MasterSharingHospitalReport;
